// extracted by mini-css-extract-plugin
export default {"wibro":"vibro_wibro__N5GtR","tremor":"vibro_tremor__jcRrp"};